// PROD
 export default {
    s3: {
      REGION: "us-east-1",
      BUCKET: "liquidando-production-users-bucket"
    },
    apiGateway: {
      REGION: "us-east-1",
      URL: "https://3spd87t7mj.execute-api.us-east-1.amazonaws.com/dev"
    },
    cognito: {
      REGION: "us-east-1",
      USER_POOL_ID: "us-east-1_lmZaOf9Ab",
      APP_CLIENT_ID: "3hfjrqjhc4c4cbumku5vrrkhha",
      IDENTITY_POOL_ID: "us-east-1:e6ed5789-5f37-46a6-a452-dd04b572fabe"
    }
};

//DEV (localHost)
/*  export default {
     s3: {
         REGION: "us-east-1",
         BUCKET: "liquidando-dev2-users-bucket"
     },
     apiGateway: {
         REGION: "us-east-1",
         URL: "https://b2ostn4qfj.execute-api.us-east-1.amazonaws.com/dev"
     },
     cognito: {
         REGION: "us-east-1",
         USER_POOL_ID: "us-east-1_AgFFL3CrX",
         APP_CLIENT_ID: "1cljida5r35btb963q0tf68qti",
         IDENTITY_POOL_ID: "us-west-2:37065c9c-b9e3-4739-a89f-29014519eadc"
     }
};
 */

// //Develop (localHost)
// export default {
//     s3: {
//         REGION: "us-west-2",
//         BUCKET: "liquidando-dev-users-bucket"
//     },
//     apiGateway: {
//         REGION: "us-east-1",
//         URL: "https://mn9nn5uaq8.execute-api.us-west-2.amazonaws.com/dev"
//     },
//     cognito: {
//         REGION: "us-west-2",
//         USER_POOL_ID: "us-west-2_sgLfmyuMm",
//         APP_CLIENT_ID: "5obcnpba81flnt9bigt1h8230b",
//         IDENTITY_POOL_ID: "us-west-2:607e1bd8-bc17-46e8-98c7-3bf446ad642d"
//     }
// };

